import { FooterProps } from 'src/components/Footer'

const mbRoot = process.env.MANGER_BOUGER_ROOT || ''

export function makeRootUrlsAbsolute(url: string) {
  if (url[0] !== '/') {
    return url
  }
  return `${mbRoot}${url}`
}

export function formatFooterLinks(json: FooterProps['menu']) {
  if (!json) {
    return []
  }
  return json.map((item) => {
    return {
      ...item,
      href: makeRootUrlsAbsolute(item.href),
      subItems: item.subItems.map((subItem) => ({
        ...subItem,
        href: makeRootUrlsAbsolute(subItem.href),
      })),
    }
  })
}

export const dotToComma = (input: string | number | null): string =>
  input?.toString()?.replace('.', ',') ?? ''

export const roundToXDecimals = (input: number, decimals: number): number =>
  Math.round(input * 10 ** decimals) / 10 ** decimals
